// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import BadgeColorConfiguration from "entity/BadgeColorConfiguration";
import BadgeColorPalette from "entity/BadgeColorPalette";
import Paging from "./Paging";
import SimpleColorConfiguration from "entity/SimpleColorConfiguration";

import { RestController, RestRequest } from "./RestController";

export default class BadgingColorController extends RestController {

    apiKeyGetColorConfiguration(socialRoomSetId: string): Promise<BadgeColorConfiguration> {
        let request = new RestRequest("/api/v1/badging/api/key/color/config", "GET", null, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<BadgeColorConfiguration>;
    }

    apiKeySetColorConfiguration(socialRoomSetId: string, config: BadgeColorConfiguration): Promise<void> {
        let request = new RestRequest("/api/v1/badging/api/key/color/config", "POST", config, { socialRoomSetId: socialRoomSetId });
        return this.requestVoid(request);
    }

    /*
     Get a color palette
     */

    getColorPalette(colorPaletteId: string): Promise<BadgeColorPalette> {
        let request = new RestRequest("/api/v1/badging/color/palette/" + colorPaletteId + "", "GET", null, undefined);
        return this.request(request, null) as Promise<BadgeColorPalette>;
    }

    /*
     Get color palettes
     */

    getColorPalettes(page?: Paging): Promise<BadgeColorPalette[]> {
        let request = new RestRequest("/api/v1/badging/color/palette", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<BadgeColorPalette[]>;
    }

    getSimpleColorConfiguration(socialRoomSetId: string): Promise<SimpleColorConfiguration> {
        let request = new RestRequest("/api/v1/badging/simple/color/config", "GET", null, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<SimpleColorConfiguration>;
    }

    removeSimpleColorConfiguration(socialRoomSetId: string): Promise<void> {
        let request = new RestRequest("/api/v1/badging/remove/simple/color/config", "POST", null, { socialRoomSetId: socialRoomSetId });
        return this.requestVoid(request);
    }

    saveSimpleColorConfiguration(socialRoomSetId: string, config: SimpleColorConfiguration): Promise<void> {
        let request = new RestRequest("/api/v1/badging/simple/color/config", "POST", config, { socialRoomSetId: socialRoomSetId });
        return this.requestVoid(request);
    }

}
